/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Admission API - Exams
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateExamScheduleRequest,
  ExamSchedule,
  ListExamSchedulesParams,
  UpdateExamScheduleRequest
} from './model/exams';





/**
 * @summary List all exam schedules
 */
export type listExamSchedulesResponse200 = {
  data: ExamSchedule[]
  status: 200
}

export type listExamSchedulesResponseSuccess = (listExamSchedulesResponse200) & {
  headers: Headers;
};
;

export type listExamSchedulesResponse = (listExamSchedulesResponseSuccess)

export const getListExamSchedulesUrl = (params?: ListExamSchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/exams?${stringifiedParams}` : `/api/exams`
}

export const listExamSchedules = async (params?: ListExamSchedulesParams, options?: RequestInit): Promise<listExamSchedulesResponse> => {
  
  const res = await fetch(getListExamSchedulesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: listExamSchedulesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listExamSchedulesResponse
}





export const getListExamSchedulesQueryKey = (params?: ListExamSchedulesParams,) => {
    return [
    `/api/exams`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getListExamSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof listExamSchedules>>, TError = unknown>(params?: ListExamSchedulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExamSchedules>>, TError, TData>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExamSchedulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExamSchedules>>> = ({ signal }) => listExamSchedules(params, { signal, ...fetchOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExamSchedules>>, TError, TData> & { queryKey: QueryKey }
}

export type ListExamSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof listExamSchedules>>>
export type ListExamSchedulesQueryError = unknown


/**
 * @summary List all exam schedules
 */

export function useListExamSchedules<TData = Awaited<ReturnType<typeof listExamSchedules>>, TError = unknown>(
 params?: ListExamSchedulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listExamSchedules>>, TError, TData>, fetch?: RequestInit}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListExamSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Create exam schedule
 */
export type createExamScheduleResponse201 = {
  data: ExamSchedule
  status: 201
}

export type createExamScheduleResponseSuccess = (createExamScheduleResponse201) & {
  headers: Headers;
};
;

export type createExamScheduleResponse = (createExamScheduleResponseSuccess)

export const getCreateExamScheduleUrl = () => {


  

  return `/api/exams`
}

export const createExamSchedule = async (createExamScheduleRequest: CreateExamScheduleRequest, options?: RequestInit): Promise<createExamScheduleResponse> => {
  
  const res = await fetch(getCreateExamScheduleUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createExamScheduleRequest,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: createExamScheduleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createExamScheduleResponse
}




export const getCreateExamScheduleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExamSchedule>>, TError,{data: CreateExamScheduleRequest}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof createExamSchedule>>, TError,{data: CreateExamScheduleRequest}, TContext> => {

const mutationKey = ['createExamSchedule'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExamSchedule>>, {data: CreateExamScheduleRequest}> = (props) => {
          const {data} = props ?? {};

          return  createExamSchedule(data,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateExamScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof createExamSchedule>>>
    export type CreateExamScheduleMutationBody = CreateExamScheduleRequest
    export type CreateExamScheduleMutationError = unknown

    /**
 * @summary Create exam schedule
 */
export const useCreateExamSchedule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExamSchedule>>, TError,{data: CreateExamScheduleRequest}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createExamSchedule>>,
        TError,
        {data: CreateExamScheduleRequest},
        TContext
      > => {
      return useMutation(getCreateExamScheduleMutationOptions(options));
    }
    
/**
 * @summary Get exam schedule
 */
export type getExamScheduleResponse200 = {
  data: ExamSchedule
  status: 200
}

export type getExamScheduleResponseSuccess = (getExamScheduleResponse200) & {
  headers: Headers;
};
;

export type getExamScheduleResponse = (getExamScheduleResponseSuccess)

export const getGetExamScheduleUrl = (id: string,) => {


  

  return `/api/exams/${id}`
}

export const getExamSchedule = async (id: string, options?: RequestInit): Promise<getExamScheduleResponse> => {
  
  const res = await fetch(getGetExamScheduleUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: getExamScheduleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getExamScheduleResponse
}





export const getGetExamScheduleQueryKey = (id: string,) => {
    return [
    `/api/exams/${id}`
    ] as const;
    }

    
export const getGetExamScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getExamSchedule>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExamSchedule>>, TError, TData>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExamScheduleQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExamSchedule>>> = ({ signal }) => getExamSchedule(id, { signal, ...fetchOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExamSchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExamScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getExamSchedule>>>
export type GetExamScheduleQueryError = unknown


/**
 * @summary Get exam schedule
 */

export function useGetExamSchedule<TData = Awaited<ReturnType<typeof getExamSchedule>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExamSchedule>>, TError, TData>, fetch?: RequestInit}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExamScheduleQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Update exam schedule
 */
export type updateExamScheduleResponse200 = {
  data: ExamSchedule
  status: 200
}

export type updateExamScheduleResponseSuccess = (updateExamScheduleResponse200) & {
  headers: Headers;
};
;

export type updateExamScheduleResponse = (updateExamScheduleResponseSuccess)

export const getUpdateExamScheduleUrl = (id: string,) => {


  

  return `/api/exams/${id}`
}

export const updateExamSchedule = async (id: string,
    updateExamScheduleRequest: UpdateExamScheduleRequest, options?: RequestInit): Promise<updateExamScheduleResponse> => {
  
  const res = await fetch(getUpdateExamScheduleUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateExamScheduleRequest,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: updateExamScheduleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateExamScheduleResponse
}




export const getUpdateExamScheduleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExamSchedule>>, TError,{id: string;data: UpdateExamScheduleRequest}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof updateExamSchedule>>, TError,{id: string;data: UpdateExamScheduleRequest}, TContext> => {

const mutationKey = ['updateExamSchedule'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateExamSchedule>>, {id: string;data: UpdateExamScheduleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateExamSchedule(id,data,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateExamScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof updateExamSchedule>>>
    export type UpdateExamScheduleMutationBody = UpdateExamScheduleRequest
    export type UpdateExamScheduleMutationError = unknown

    /**
 * @summary Update exam schedule
 */
export const useUpdateExamSchedule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExamSchedule>>, TError,{id: string;data: UpdateExamScheduleRequest}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateExamSchedule>>,
        TError,
        {id: string;data: UpdateExamScheduleRequest},
        TContext
      > => {
      return useMutation(getUpdateExamScheduleMutationOptions(options));
    }
    
/**
 * @summary Delete exam schedule
 */
export type deleteExamScheduleResponse204 = {
  data: void
  status: 204
}

export type deleteExamScheduleResponseSuccess = (deleteExamScheduleResponse204) & {
  headers: Headers;
};
;

export type deleteExamScheduleResponse = (deleteExamScheduleResponseSuccess)

export const getDeleteExamScheduleUrl = (id: string,) => {


  

  return `/api/exams/${id}`
}

export const deleteExamSchedule = async (id: string, options?: RequestInit): Promise<deleteExamScheduleResponse> => {
  
  const res = await fetch(getDeleteExamScheduleUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: deleteExamScheduleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteExamScheduleResponse
}




export const getDeleteExamScheduleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExamSchedule>>, TError,{id: string}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof deleteExamSchedule>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteExamSchedule'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExamSchedule>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteExamSchedule(id,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteExamScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExamSchedule>>>
    
    export type DeleteExamScheduleMutationError = unknown

    /**
 * @summary Delete exam schedule
 */
export const useDeleteExamSchedule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExamSchedule>>, TError,{id: string}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteExamSchedule>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteExamScheduleMutationOptions(options));
    }
    
